import script from "./phasing-background.vue?vue&type=script&setup=true&lang=ts"
export * from "./phasing-background.vue?vue&type=script&setup=true&lang=ts"

import "./phasing-background.vue?vue&type=style&index=0&id=458d8154&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-458d8154"]])

export default __exports__